<template>
  <a-modal
    :title="$t('导入商品')"
    :visible="open"
    :confirm-loading="uploading"
    :okText="$t('导入')"
    :cancelText="$t('取消')"
    @cancel="importExcelHandleCancel"
    @ok="importExcelHandleChange"
  >
    <a-spin :tip="$t('上传中')" :spinning="uploading">
      <a-upload-dragger
        name="file"
        accept=".xlsx, .xls"
        :file-list="fileList"
        :multiple="false"
        :remove="handleRemove"
        :before-upload="beforeUpload"
      >
        <p class="ant-upload-drag-icon">
          <a-icon type="inbox" />
        </p>
        <p class="ant-upload-text">
          {{ $t('请将电子表格拖拽到此处') }}
        </p>
        <p class="ant-upload-hint">
          {{ $t('支持单个上传，也可以点击后选择文件上传') }}
        </p>
      </a-upload-dragger>
    </a-spin>
  </a-modal>
</template>

<script>
import { importGoods } from '@/api/goods/goods'

export default {
  name: 'ImportExcel',
  props: {},
  components: {},
  data() {
    return {
      open: false,
      uploadStatus: '',
      fileList: [],
      // 是否禁用上传
      uploading: false,
      updateSupport: 0
    }
  },
  filters: {},
  created() {
  },
  computed: {},
  watch: {},
  methods: {
    /** 导入excel窗体关闭 */
    importExcelHandleCancel(e) {
      this.open = false
      this.fileList = []
      // 关闭后刷新列表
      this.$emit('ok')
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen() {
      this.open = true
    },
    beforeUpload(file) {
      this.fileList = [file]
      return false
    },
    /** 导入excel */
    importExcelHandleChange() {
      this.uploading = true
      const { fileList } = this
      const formData = new FormData()
      formData.append('file', fileList[0])
      formData.append('updateSupport', this.updateSupport)
      importGoods(formData).then(response => {
        if (response.code === 1 || response.code === 20001) {
          this.fileList = []
          this.$message.success(response.message)
          this.open = false
          this.$emit('ok')
        } else {
          this.$message.error(response.message)
        }
      }).finally(() => {
        this.uploading = false
      })
    },
    handleRemove() {
      this.fileList = []
      this.uploading = false
    }
  }
}
</script>
